import React from "react";
import {Route, Routes} from "react-router-dom";
import CreateDepartment from "../container/department/CreateDepartment";
import UpdateDepartment from "../container/department/UpdateDepartment";
import ConfigureDangerEvaluation from "../container/dangerEvaluation/ConfigureDangerEvaluation";
import DepartmentList from "../container/department/DepartmentList";

const Department = () => {
  return (
    <Routes>
      <Route path="/*" element={<DepartmentList />} />
      <Route path="Configure" element={<ConfigureDangerEvaluation />} />
      <Route path="Create" element={<CreateDepartment />} />
      <Route path="Edit/:id" element={<UpdateDepartment />} />
    </Routes>
  );
};

export default Department;
